import * as RadixSelect from "@radix-ui/react-select";
import styled from "styled-components";
import { css } from "styled-components";
import { Flex } from "../../Flex";
import { getThemeSpace } from "../../helpers";
export const ellipsis = css `
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
`;
export const TriggerSelector = styled(Flex) `
	width: 100%;
	border: none;
	outline: none;
	border-radius: 4px;
	cursor: pointer;

	p {
		text-align: left;
		${ellipsis}
	}

	&[data-state="open"] {
		background-color: var(--surface-accent-light);
	}

	&:hover {
		background-color: var(--surface-accent-light);
	}

	&[data-disabled] {
		background-color: var(--surface-primary);
		cursor: not-allowed;
	}

	${({ size }) => {
    if (size === "small") {
        return css `
				padding: ${getThemeSpace("4")} ${getThemeSpace("4")};
			`;
    }
    return css `
			padding: ${getThemeSpace("8")} ${getThemeSpace("16")};
		`;
}};
`;
export const ContentSelector = styled(RadixSelect.Content) `
	background-color: var(--neutral-white);
	outline: 1px solid var(--border-primary);
	box-shadow: 0px 3px 8px 0px #00000040; // validar com o Edu qual o token deveria ser usado aqui.
	border-radius: 4px;
	padding: 4px;

	overflow-y: auto;

	${({ size }) => {
    if (size === "small") {
        return css `
				width: 300px;
			`;
    }
    return css `
			width: var(--radix-select-trigger-width);
		`;
}};
`;
export const ItemSelector = styled(Flex) `
	cursor: pointer;
	padding: 8px;
	transition: background-color 300ms ease-in-out;
	background-color: var(--surface-white);
	border-radius: 4px;

	> p {
		width: 100%;
	}

	&:focus {
		outline: transparent;
	}

	&[data-state="checked"] {
		background-color: var(--surface-accent-light) !important;
		border: 1px solid var(--border-active) !important;
	}

	&:hover:not([data-disabled]:not([data-state="checked"])) {
		background-color: var(--surface-accent-light) !important;
	}

	&[data-disabled]:not([data-state="checked"]) {
		background-color: var(--surface-primary);
		cursor: not-allowed;
	}

	&[data-state="checked"] {
		background-color: var(--surface-white);
		cursor: default;

		span {
			color: var(--text-link);
		}
	}

	.label-field {
		width: 100%;
	}

	.hidden-in-options {
		display: none;
	}
`;
export const ItemSelectorExpanded = styled.button `
	cursor: pointer;
	padding: 8px;
	transition: background-color 300ms ease-in-out;
	background-color: var(--surface-white);
	border-radius: 4px;

	> p {
		width: 100%;
	}

	&:hover {
		background-color: var(--surface-accent-light);
	}

	${({ disabled }) => disabled &&
    css `
			background-color: var(--surface-primary);
			cursor: not-allowed;

			&:hover {
				background-color: var(--surface-primary);
			}
		`};

	${({ selected }) => selected &&
    css `
			background-color: var(--surface-accent-light);
			border: 1px solid var(--border-active);
		`};
`;
//# sourceMappingURL=styles.js.map